var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{attrs:{"shadow":"never"}},[_c('div',{staticStyle:{"height":"500px","width":"auto"}},[_c('div',{staticClass:"test-div"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"http://szsxtravel.top/1.png","alt":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }